import {useContext, useEffect, useState} from "react";
import {Button, Col, Icon, Row, Space, Typography} from "@bezlimit/bezlimit-ui";
import {Divider, notification, Popover} from "antd";
import _ from "lodash";
import "./style.scss";
import Clipboard from "react-clipboard.js";
// core
import {IReservations} from "../../../../../../core/models/Reservations";
import {LayoutContext, ModalContext} from "../../../../../../core/Contexts";
// components
import Phone from "../../../../numbers/list/default/info/phone";
import Description from "../../../reservationList/info/description";
import Status from "./status";
import NumberListInfoModal from "../../../../../modal/numberListInfo";
import {observer} from "mobx-react";
import RemoveSim from "../../../../../modal/removeSim";
import AttachToEsim from "../../../../../modal/attachToEsim";
import {createSearchParams, useNavigate} from "react-router-dom";
import closeNPS from "../../../../../../images/delete_nps.svg";
import vectorNPS from "../../../../../../images/vector_nps.svg";
import NPS from "../../../../../../images/nps3.svg";
import Store from "../../../../../../stores";
import npsIcon from "../../../../../../images/nps_icon.svg";
import fallSvg from "../../../../../../images/fall2.svg";
import AgreementImportantModal from "../../../../../modal/agreementImportantModal";
import ErrorSignUrl from "../../../../../modal/errorSignUrl";
import copy from "../../../../../../images/copy2.svg";
import toShare from "../../../../../../images/toShare.svg";
import Success from "../../../../../../images/success.png";
import ShareDocScontractkModal from "../../../../../modal/shareDocScontract";

export default observer(function Item({
    id,
    sim,
    phone_number: phone,
    pay_type,
    additional_data,
    removed_at,
    can_change_sim,
    nps,
    can_nps,
    phone: {
        docs,
        // status,
        activated_at,
        unblock_sum,
        type,
        mask: {category}
    },
    tariff,
    verification,
    sign_url,
    status
}: IReservations) {
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const [openSimType, setOpenSimType] = useState(false);
    const docContract = _.chain(docs)
        .filter(({code}) => _.isEqual(code, "s_contract"))
        .map((i) => {
            return i;
        })
        .valueOf();

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };
    const handleOpenChangeMenu = (newOpen: boolean) => {
        setOpenMenu(newOpen);
    };

    const onShare = () => {
        contextModal?.setChildren(<ShareDocScontractkModal docContract={docContract} />);
        contextModal?.setCssClass(" modal-docs-contract-share");
        contextModal?.setVisible(true);
        contextModal?.setOnCancel(() => () => {
            contextModal?.setCssClass("");
            contextModal?.setVisible(false);
        });
        setOpen(false);
    };

    const onSuccess = () => {
        notification.open({
            message: "",
            placement: !_.gte(contextLayout?.width ?? 0, 568) ? "top" : "topRight",
            closeIcon: undefined,
            icon: <img src={Success} width={34} alt="superLink" />,
            className: "copy-referral-delivery",
            description: "Ссылка скопирована в буфер обмена",
            duration: 2
        });
        setOpen(false);
    };

    const content = (
        <div className="content-popover-docs">
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Clipboard
                        data-clipboard-text={docContract[0]?.link}
                        className={`ant-btn ant-btn-primary`}
                        onSuccess={onSuccess}
                    >
                        Копировать <img src={copy} width={22} alt="superLink" />
                    </Clipboard>
                </Col>
                <Divider />
                <Col span={24}>
                    <Button onClick={onShare}>
                        Поделиться <img src={toShare} width={22} alt="superLink" />
                    </Button>
                </Col>
            </Row>
        </div>
    );

    const onCancel = () => {
        navigate(`/reservation`);
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    const onClickDokument = () => {
        if (_.isEqual(verification, "sign") && !_.isEqual(sign_url, "")) {
            contextModal?.setMaskStyle({
                background:
                    "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                // @ts-ignore
                WebkitBackdropFilter: " blur(12px)",
                backdropFilter: " blur(12px)"
            });
            contextModal?.setCssClass(" bl-modal-agreement-passport-add");
            contextModal?.setChildren(
                <AgreementImportantModal
                    tariffId={tariff?.id}
                    phone_number={phone}
                    signUrl={sign_url}
                />
            );
            contextModal?.setVisible(true);
        } else if (_.isEqual(verification, "sign") && _.isEqual(sign_url, "")) {
            contextModal?.setMaskStyle({
                background:
                    "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                // @ts-ignore
                WebkitBackdropFilter: " blur(12px)",
                backdropFilter: " blur(12px)"
            });
            contextModal?.setCssClass(" bl-modal-success-passport-add");
            contextModal?.setChildren(<ErrorSignUrl />);
            contextModal?.setVisible(true);
            contextModal?.setOnCancel(() => onCancel);
        } else {
            navigate(`/signature/step1?id=${tariff?.id}&phone=${phone}`);
        }
    };

    const onClick = () => {
        contextModal?.setChildren(
            <NumberListInfoModal
                phone={phone}
                tariffName={tariff?.name}
                minutes={tariff?.minutes}
                internet={tariff?.internet}
                type={type}
                sms={tariff?.sms}
                id={id}
            />
        );
        contextModal?.setVisible(true);
    };

    const onRemoveSim = () => {
        contextModal?.setCssClass("");
        contextModal?.setChildren(<RemoveSim phone={phone} sim={sim} id={id} />);
        contextModal?.setVisible(true);
        setOpenSimType(false);
        setOpenMenu(false);
    };

    const onAttachEsim = () => {
        contextModal?.setCssClass(" bl-modal-attach-to-esim");
        contextModal?.setChildren(<AttachToEsim phone={phone} id={id} />);
        contextModal?.setVisible(true);
        setOpenSimType(false);
        setOpenMenu(false);
    };

    const simTypeContent = (
        <div className="content-popover-sim-type">
            <button type="button" className="btn-sim-type" onClick={onRemoveSim}>
                SIM
            </button>
            <button type="button" className="btn-sim-type" onClick={onAttachEsim}>
                eSIM
            </button>
        </div>
    );
    let phoneNPS = "";
    if (additional_data?.nps) {
        phoneNPS = additional_data?.nps.phone;
    }

    const onCloseNotification = () => {
        if (_.isEqual(location.search, "") && location.href.includes("?")) {
            history.pushState({}, "", location.href.split("?")[0]);
            Store.nps.phone = null;
        }
    };

    useEffect(() => {
        onCloseNotification();
    }, []);

    const notif = () => {
        Store.nps.phone = phone.toString();
        navigate({
            search: createSearchParams({
                nps: phone.toString()
            }).toString(),
            pathname: "/numbers"
        });
        openNotification();
    };

    const contentMenu = (
        <div className="content-popover-menu">
            <Row gutter={[8, 8]}>
                {_.isEqual(can_nps, true) && _.isEqual(verification, "done") && (
                    <Col span={24}>
                        <Button type="primary" className="btn-nps-notif" onClick={notif}>
                            Подключить скидку
                        </Button>
                    </Col>
                )}

                {_.isEqual(can_change_sim, true) && _.isEqual(verification, "done") && (
                    <Col span={24}>
                        <Popover
                            className="popover-sim-type"
                            content={simTypeContent}
                            trigger="click"
                            placement="rightTop"
                            overlayClassName="popover-sim-type-overlay"
                            autoAdjustOverflow={false}
                            align={{offset: [-160, 0]}}
                            open={openSimType}
                            onOpenChange={setOpenSimType}
                        >
                            <Button className="btn-remove-sim">Смена СИМ-карты</Button>
                        </Popover>
                    </Col>
                )}
            </Row>
        </div>
    );

    const openNotification = () => {
        notification.open({
            message: (
                <Typography as="div" className="massege">
                    <Typography as="div">
                        {"Заверши бронирование по акции «Не плати за связь»"}
                    </Typography>
                </Typography>
            ),
            description: (
                <Typography as="div" className="description">
                    <img src={NPS} width={38} />
                    {phone}
                </Typography>
            ),
            className: "notification-nps",
            style: {
                width: 600
            },
            duration: 0,
            placement: "top",
            top: _.gte(contextLayout?.width, 431) ? 20 : 0,
            onClick: () => {
                navigate({
                    search: createSearchParams({
                        nps: phone.toString()
                    }).toString(),
                    pathname: "/numbers"
                });
            },
            onClose: onCloseNotification,
            closeIcon: <img src={closeNPS} width={24} />,
            icon: <img src={vectorNPS} width={_.gte(contextLayout?.width, 431) ? 42 : 29} />
        });
    };

    return (
        <Typography
            as="div"
            className={`bl-activation-list-items-item${
                _.isEqual(pay_type, "super_link")
                    ? " bl-super_link"
                    : !_.isEqual(phoneNPS, "")
                    ? " bl-nps"
                    : ""
            } ${
                _.isEqual(verification, "sign") &&
                !_.isEqual(additional_data?.super_link_type, "envelope")
                    ? "_violett"
                    : !_.isEqual(verification, "done") &&
                      !_.isEqual(additional_data?.super_link_type, "envelope")
                    ? "_red"
                    : _.isEqual(additional_data?.super_link_type, "envelope")
                    ? "_envelope"
                    : ""
            }`}
        >
            <Row gutter={[16, _.gt(contextLayout?.width ?? 0, 768) ? 16 : 8]}>
                <Col xs={12} lg={16}>
                    <Row gutter={16} className="left">
                        <Col xs={24} xl={5} className="phone">
                            <Space direction="horizontal" size={8}>
                                <Phone category={category} phone={phone} />
                                {_.lte(contextLayout?.width, 992) ? (
                                    <Icon
                                        className="info"
                                        name="info"
                                        size="16"
                                        onClick={onClick}
                                    />
                                ) : null}
                            </Space>
                            {_.lte(contextLayout?.width, 528) && (
                                <Typography as="div" className="phone-tariff-name">
                                    {tariff ? tariff.name : "Не определен"}
                                </Typography>
                            )}
                        </Col>
                        <Col xs={24} xl={_.isEqual(can_nps, true) ? 13 : 19} className="desc">
                            {tariff ? (
                                <Description
                                    tariffName={tariff.name}
                                    minutes={tariff.minutes}
                                    internet={tariff.internet}
                                    sms={tariff.sms}
                                    pay_type={pay_type}
                                    additional_data={additional_data}
                                    phoneNPS={phoneNPS}
                                />
                            ) : (
                                <Typography
                                    as="span"
                                    color="#fff"
                                    size={17}
                                    className="tariff-name-mob"
                                >
                                    Не определен
                                </Typography>
                            )}
                        </Col>
                        {!_.isEqual(phoneNPS, "") ? (
                            <Col xs={24} xl={_.isEqual(can_nps, true) ? 6 : 17}>
                                <Typography
                                    as="div"
                                    className={
                                        _.isEqual(can_change_sim, true) && _.isEqual(can_nps, true)
                                            ? "nps-number-true"
                                            : "nps-number"
                                    }
                                >
                                    <Space direction="horizontal">
                                        <img src={npsIcon} width={22} alt="superLink" />
                                        {phoneNPS}
                                    </Space>
                                </Typography>
                            </Col>
                        ) : null}
                    </Row>
                </Col>
                <Col xs={12} lg={8} className="status">
                    <Row>
                        <Col
                            span={
                                (_.isEqual(can_nps, true) &&
                                    _.isEqual(verification, "done") &&
                                    !_.isEqual(additional_data?.super_link_type, "envelope")) ||
                                (_.isEqual(can_change_sim, true) &&
                                    _.isEqual(verification, "done") &&
                                    !_.isEqual(additional_data?.super_link_type, "envelope"))
                                    ? _.gte(contextLayout?.width ?? 0, 528)
                                        ? 23
                                        : 22
                                    : 24
                            }
                        >
                            <Status
                                status={status}
                                activated_at={activated_at}
                                unblock_sum={unblock_sum}
                                pay_type={pay_type}
                                verification={verification}
                                additional_data={additional_data}
                            />
                        </Col>
                        {!_.isEqual(additional_data?.super_link_type, "envelope") ? (
                            <Col
                                span={
                                    (_.isEqual(can_nps, true) && _.isEqual(verification, "done")) ||
                                    (_.isEqual(can_change_sim, true) &&
                                        _.isEqual(verification, "done"))
                                        ? _.gte(contextLayout?.width ?? 0, 528)
                                            ? 1
                                            : 2
                                        : 0
                                }
                            >
                                <Popover
                                    className="popover-docs-menu"
                                    content={contentMenu}
                                    trigger="click"
                                    open={openMenu}
                                    onOpenChange={handleOpenChangeMenu}
                                    placement="leftTop"
                                >
                                    <Button
                                        className="btn-dots-menu"
                                        icon={<Icon className="" name="dots_menu" />}
                                    ></Button>
                                </Popover>
                            </Col>
                        ) : null}
                    </Row>
                </Col>
                {!_.isEqual(additional_data?.super_link_type, "envelope") ? (
                    _.isEqual(verification, "sign") ? (
                        <Col span={24}>
                            {_.lte(contextLayout?.width, 528) ? (
                                <Typography
                                    as="div"
                                    className="add-passport-violet"
                                    onClick={onClickDokument}
                                >
                                    <img src={fallSvg} width={16} alt="" /> {"Подпишите договор"}
                                </Typography>
                            ) : (
                                <Typography
                                    as="div"
                                    className="add-passport-violet grid-type-list"
                                    onClick={onClickDokument}
                                >
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подпишите договор"}
                                    </Typography>
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подпишите договор"}
                                    </Typography>
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подпишите договор"}
                                    </Typography>
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подпишите договор"}
                                    </Typography>
                                </Typography>
                            )}
                        </Col>
                    ) : _.isEqual(verification, "done") ? null : (
                        <Col span={24}>
                            {_.lte(contextLayout?.width, 528) ? (
                                <Typography
                                    as="div"
                                    className="add-passport-red"
                                    onClick={onClickDokument}
                                >
                                    <img src={fallSvg} width={16} alt="" />{" "}
                                    {"Подтвердите паспортные данные"}
                                </Typography>
                            ) : (
                                <Typography
                                    as="div"
                                    className="add-passport-red grid-type-list"
                                    onClick={onClickDokument}
                                >
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подтвердите паспортные данные"}
                                    </Typography>
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подтвердите паспортные данные"}
                                    </Typography>
                                    <Typography as="div">
                                        <img src={fallSvg} width={16} alt="" />{" "}
                                        {"Подтвердите паспортные данные"}
                                    </Typography>
                                </Typography>
                            )}
                        </Col>
                    )
                ) : null}

                {!_.isEqual(docContract.length, 0) &&
                    !_.isEqual(additional_data?.super_link_type, "envelope") && (
                        <Col span={24}>
                            <Popover
                                className="popover-docs-contract"
                                content={content}
                                trigger="click"
                                open={open}
                                onOpenChange={handleOpenChange}
                                placement="bottomRight"
                            >
                                <Button
                                    className={open ? "" : "btn-docs-scontract"}
                                    type={open ? "primary" : "default"}
                                >
                                    Подписать дистанционно
                                </Button>
                            </Popover>
                        </Col>
                    )}
            </Row>
        </Typography>
    );
});
